import { render, staticRenderFns } from "./TicketCreateModal.vue?vue&type=template&id=7c58661c&scoped=true&"
import script from "./TicketCreateModal.vue?vue&type=script&lang=ts&"
export * from "./TicketCreateModal.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/ticket-create-modal.css?vue&type=style&index=0&id=7c58661c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c58661c",
  null
  
)

export default component.exports